import React, { FunctionComponent } from 'react';
import { userSelectors } from '../../../../../../../app/resource/user/user.selectors';
import { useSelectWithParams } from '../../../../../../../utils/selector.utils';
import { IUserDetailsProps } from './types';
import { CircularAvatar } from '../../../../CustomAvatar';

export const UserDetails: FunctionComponent<IUserDetailsProps> = ({ userId }) => {
  const user = useSelectWithParams(userSelectors.selectResourceById, userId);

  return (
    user && (
      <div className="drop-item flex aic">
        <div className="mr-1">
          <CircularAvatar src={user.image} title={`${user.firstName} ${user.lastName}`} cursorPointer={false} />
        </div>
        <h3 className="mr-3">
          {`${user.firstName} ${user.lastName}`} <span className="d-block w100">{user.jobTitle}</span>
        </h3>
      </div>
    )
  );
};
